// 需要更新状态的消息类型
import store from '@/store'
import { computed } from 'vue'

export default function useUpdateMsg(data) {
  // 添加数据校验，避免 data 为 undefined 或 null 时出错
  if (!data || !data.ext) return
  // 当前回话消息
  const currentMsgs = computed(() => store.state.chat.currentMsgs)
  // 消息列表
  const msgList = computed(() => store.state.chat.msgList)
  // 提取默认值，避免重复解构
  const defaultValues = { chatType: 'group', chatId: '' }
  const { chatType, chatId } = currentMsgs?.value[0] || defaultValues
  const chatList = msgList.value[chatType]?.[chatId] || [] //当前会话消息
  const msgId = data?.ext?.msgId // 透传消息的id

  // 找出和透传消息mid对应的消息
  const index = () => chatList.findIndex(item => item.mid == msgId)
  let msgNewDataList = []
  if (index !== -1) {
    msgNewDataList = chatList.map(item => {
      if (item.mid == msgId) {
        return {
          ...item,
          msg: {
            ...item.msg,
            ...data.ext
          }
        }
      }
      return item
    })
  }

  return {
    msgNewDataList,
    chatType,
    chatId
  }
}
